export default __webpack_public_path__ + "static/media/Binance-logo.42a778df.png";